import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createPageUrl } from "@/utils";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty,
  CommandGroup, CommandItem,
} from "@/components/ui/command";
import { navGroups } from "./navConfig";
import { useAuth } from "@/lib/AuthContext";

export default function CommandMenu({ open, setOpen }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const isExternal = user?.role === "external";

  useEffect(() => {
    const down = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [setOpen]);

  const go = (page) => {
    setOpen(false);
    navigate(createPageUrl(page));
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Søk etter side eller modul..." />
      <CommandList>
        <CommandEmpty>Ingen treff.</CommandEmpty>
        {navGroups.map((group, gi) => {
          const items = group.items
            .flatMap((item) => [item, ...(item.children || [])])
            .filter((it) => (!it.adminOnly || isAdmin) && (!isExternal || it.externalOk));
          if (items.length === 0) return null;
          return (
            <CommandGroup key={gi} heading={group.label || "Oversikt"}>
              {items.map((it) => {
                const Icon = it.icon;
                return (
                  <CommandItem key={it.page} value={it.name} onSelect={() => go(it.page)} className="cursor-pointer">
                    <Icon className="w-4 h-4 mr-2 text-slate-500" />
                    {it.name}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          );
        })}
      </CommandList>
    </CommandDialog>
  );
}
